import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { showToast } from '../../../services';
import { profileActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';

import menuIcon from '../../../assets/img/menu-icon.svg';
import questionIcon from '../../../assets/img/question.svg';

const initialState = {
    username: '',
    firstname: '',
    lastname: '',
    email: '',
    age: '',
    gender: '',
    submitted: false
};

const EditProfile = () => {
    const [state, setState] = useState(initialState);
    const dispatch = useDispatch();
    const history = useHistory();
    const loggedUser = useLoggedUser();

    const { loading, myprofile, error } = useSelector((state) => state.myprofile);

    useEffect(() => {
        if (loggedUser) {
            dispatch(profileActions.fetchMyprofile(loggedUser.data.StudentProfileID));
        }
    }, [dispatch, loggedUser.data.StudentProfileID]);

    useEffect(() => {
        if (myprofile && myprofile.length > 0) {
            // Populate state with the fetched profile data
            setState({
                username: myprofile[0]?.UserName || '',
                firstname: myprofile[0]?.FirstName || '',
                lastname: myprofile[0]?.LastName || '',
                email: myprofile[0]?.EmailAddress || '',
                age: myprofile[0]?.Age || '',
                gender: myprofile[0]?.Gender || '',
                submitted: false
            });
        }
    }, [myprofile]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleEmailValidation = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setState(prevState => ({ ...prevState, submitted: true }));

        const { username, email } = state;

        if (username && handleEmailValidation(email)) {
            const profileData = {
                UserName: state.username,
                FirstName: state.firstname,
                LastName: state.lastname,
                EmailAddress: state.email,
                Age: state.age,
                Gender: state.gender,
                StudentProfileID: loggedUser.data.StudentProfileID,
                ClassID: loggedUser.data.ClassID
            };
            dispatch(profileActions.updateMyprofile(profileData))
                .then(response => {
                    showToast(response.responseMessage, 'success');
                    history.push('/myprofile');
                })
                .catch(error => {
                    showToast(error.toString(), 'error');
                });
        }
    };

    const { username, firstname, lastname, email, age, gender, submitted } = state;

    return (
        <React.Fragment>
            <div className="container-fluid signup-page">
                <nav className="navbar navbar-expand-sm">
                    <div className="container-fluid">
                        <a className="navbar-brand">
                            <div className="w-20 d-flex align-items-center justify-content-center">
                                <img className="w-100" src={menuIcon} alt="Menu Icon" />
                            </div>
                        </a>
                        <div className="collapse navbar-collapse" id="mynavbar">
                            <ul className="navbar-nav me-auto"></ul>
                            <form className="d-flex justify-content-end">
                                <img className="w-100" src={questionIcon} alt="Question Icon" />
                            </form>
                        </div>
                    </div>
                </nav>

                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-left flex-column mt-5">
                        <h2 className="b-font sign-up">Edit Profile Data</h2>
                    </div>

                    <form className="signup-form" onSubmit={handleSubmit}>
                        <div className="d-flex justify-content-between w-100 align-items-center signup-form-div">
                            <div className="left-form">
                                <div className={'d-flex flex-column' + (submitted && !username ? ' has-error' : '')}>
                                    <label className="from-label b-font" htmlFor="username">Username *</label>
                                    <input
                                        type="text"
                                        id="username"
                                        name="username"
                                        value={username}
                                        onChange={handleChange}
                                    />
                                    {submitted && !username && (
                                        <div className="help-block">Username is required</div>
                                    )}
                                </div>

                                <div className="d-flex flex-column mt-3">
                                    <label className="from-label b-font" htmlFor="firstname">First Name</label>
                                    <input
                                        type="text"
                                        id="firstname"
                                        name="firstname"
                                        value={firstname}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className={'d-flex flex-column mt-3' + (submitted && !email ? ' has-error' : '')}>
                                    <label className="from-label b-font" htmlFor="email">Email*</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={handleChange}
                                    />
                                    {submitted && email && !handleEmailValidation(email) && (
                                        <div className="help-block">Invalid email address</div>
                                    )}
                                    {submitted && !email && (
                                        <div className="help-block">Email address required</div>
                                    )}
                                </div>
                            </div>

                            <div>
                                <div className="avatar-upload d-flex flex-column">
                                    {/* Avatar upload will be implemented here */}
                                </div>

                                <div className="d-flex flex-column mt-3">
                                    <label className="from-label b-font" htmlFor="lastname">Last Name</label>
                                    <input
                                        type="text"
                                        id="lastname"
                                        name="lastname"
                                        value={lastname}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="d-flex flex-column mt-3">
                                    <label className="from-label b-font" htmlFor="age">Age</label>
                                    <input
                                        type="number"
                                        id="age"
                                        name="age"
                                        value={age}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === '-' || e.key === '+') {
                                                e.preventDefault();
                                            }
                                        }}
                                        min="0"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="cntr gender-div" style={{ marginLeft: '100px' }}>
                            <label htmlFor="opt1" className="radio">
                                <input
                                    type="radio"
                                    name="gender"
                                    id="opt1"
                                    className="hidden"
                                    value="Boy"
                                    checked={gender === 'Boy'}
                                    onChange={handleChange}
                                />
                                <span className="label"></span>Boy
                            </label>
                            <label htmlFor="opt2" className="radio">
                                <input
                                    type="radio"
                                    name="gender"
                                    id="opt2"
                                    className="hidden"
                                    value="Girl"
                                    checked={gender === 'Girl'}
                                    onChange={handleChange}
                                />
                                <span className="label"></span>Girl
                            </label>
                            <label htmlFor="opt3" className="radio">
                                <input
                                    type="radio"
                                    name="gender"
                                    id="opt3"
                                    className="hidden"
                                    value="Prefer not to share"
                                    checked={gender === 'Prefer not to share'}
                                    onChange={handleChange}
                                />
                                <span className="label"></span>Prefer not to share
                            </label>
                            <button className="accept-btn mt-2 pull-right" type="submit" style={{ marginLeft: '50px' }}>Update</button>
                        </div>

                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EditProfile;